/* =====================================================================
   ARMAS M&S · BARRA DE PROGRESO DE ENVÍO GRATIS — JS aditivo (v2: EventBus Ultra + /cart.js)
   ---------------------------------------------------------------------
   Qué hace:
   1. Lee data-cart-total (centavos) y data-amount-cents (umbral, centavos)
      del contenedor .cart-shipping.js-cart-shipping.
   2. Calcula % = data-cart-total / data-amount-cents * 100.
   3. Togglea la clase de etapa: is-stage-red / -yellow / -green / -complete.
   4. Escribe el mensaje principal (.js-cart-shipping-amount-msg) y el
      subtexto (.js-cart-shipping-sub), y fija el ancho del relleno vía la
      variable CSS --shipping-bar-progress-value.
   5. Se re-ejecuta cuando el carrito cambia: observa mutaciones del nodo
      y escucha eventos comunes del tema. MutationObserver se DESCONECTA
      mientras escribimos y se RECONECTA después (evita bucles de reflujo).
   ---------------------------------------------------------------------
   Integración Liquid: incluir este archivo una sola vez (defer). El JS
   detecta automáticamente cualquier .cart-shipping presente y se re-aplica
   a nodos nuevos (drawer que se inyecta, etc.).
   ===================================================================== */
(function () {
  'use strict';

  var THRESHOLD_DEFAULT = 80000; // $800 MXN en centavos (fallback)

  // Subtextos por etapa (vacío en rojo).
  var SUBTEXT = {
    red:      '',
    yellow:   'Estás cerca del envío GRATIS',
    green:    'Solo un poco más',
    complete: '\u00A1FELICIDADES!'
  };

  // Formatea centavos -> "$1,234" (MXN, sin decimales).
  function formatMoney(cents) {
    var pesos = Math.round(Math.max(0, cents) / 100);
    try {
      return '$' + pesos.toLocaleString('es-MX');
    } catch (e) {
      return '$' + String(pesos).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }

  // Determina la etapa a partir del porcentaje (sin recortar).
  //   0–30%  rojo · 31–80% amarillo · 81–99% verde · 100% completo
  function stageFor(pct) {
    if (pct >= 100) return 'complete';
    if (pct >= 81)  return 'green';
    if (pct >= 31)  return 'yellow';
    return 'red';
  }

  var STAGE_CLASSES = ['is-stage-red', 'is-stage-yellow', 'is-stage-green', 'is-stage-complete'];

  // Aplica el estado al contenedor. Desconecta el observer mientras escribe.
  function render(root) {
    var observer = root.__shpObserver;
    if (observer) observer.disconnect();           // <- evita bucle de reflujo

    var total     = parseInt(root.getAttribute('data-cart-total') || '0', 10) || 0;
    var threshold = parseInt(root.getAttribute('data-amount-cents') || THRESHOLD_DEFAULT, 10) || THRESHOLD_DEFAULT;

    // Modo PROYECCIÓN (PDP): si existe data-shp-projection (precio del producto
    // en centavos), proyectamos el avance como si el producto YA estuviera en
    // el carrito -> "Con este producto te faltarían $XXX para envío gratis".
    var projAttr   = root.getAttribute('data-shp-projection');
    var projection = projAttr !== null && projAttr !== '' ? (parseInt(projAttr, 10) || 0) : null;
    var effective  = projection !== null ? total + projection : total;

    var pct      = threshold > 0 ? (effective / threshold) * 100 : 0;
    var clamped  = Math.max(0, Math.min(100, pct));
    var stage    = stageFor(pct);
    var remaining = Math.max(0, threshold - effective);

    // 1) clase de etapa
    for (var i = 0; i < STAGE_CLASSES.length; i++) root.classList.remove(STAGE_CLASSES[i]);
    root.classList.add('is-stage-' + stage);
    root.setAttribute('data-stage', stage);

    // 2) ancho del relleno (variable CSS, en el contenedor para que el camión
    //    y el relleno la compartan)
    root.style.setProperty('--shipping-bar-progress-value', clamped.toFixed(2) + '%');
    var bar = root.querySelector('.js-cart-shipping-progress-bar');
    if (bar) {
      bar.style.setProperty('--shipping-bar-progress-value', clamped.toFixed(2) + '%');
      bar.setAttribute('aria-valuenow', Math.round(clamped));
    }

    // 3) mensaje principal
    var msg = root.querySelector('.js-cart-shipping-amount-msg');
    if (msg) {
      if (projection !== null) {
        // PDP — proyección con el precio del producto visible
        if (stage === 'complete') {
          msg.innerHTML = 'Con este producto tienes <span class="cart-shipping__free">env\u00EDo GRATIS</span>';
        } else {
          msg.innerHTML = 'Con este producto te faltar\u00EDan <span class="cart-shipping__amount">' +
                          formatMoney(remaining) + '</span> para el <span class="cart-shipping__free">env\u00EDo GRATIS</span>';
        }
      } else if (stage === 'complete') {
        msg.innerHTML = '\u00A1Ya tienes <span class="cart-shipping__free">env\u00EDo GRATIS</span>!';
      } else {
        msg.innerHTML = 'Agrega <span class="cart-shipping__amount">' + formatMoney(remaining) +
                        '</span> m\u00E1s y tu env\u00EDo es <span class="cart-shipping__free">GRATIS</span>';
      }
    }

    // 4) subtexto por etapa
    var sub = root.querySelector('.js-cart-shipping-sub');
    if (sub) sub.textContent = SUBTEXT[stage];

    // 5) celebración una sola vez (al entrar a "complete")
    if (stage === 'complete' && root.__prevStage && root.__prevStage !== 'complete') {
      celebrate(root);
    }
    root.__prevStage = stage;

    if (observer) reconnect(root, observer);        // <- reconecta tras escribir
  }

  // Dispara la animación de celebración (sweep + pop) una sola vez.
  function celebrate(root) {
    root.classList.remove('is-celebrating');
    // reflow forzado para reiniciar la animación
    void root.offsetWidth;
    root.classList.add('is-celebrating');
    window.setTimeout(function () { root.classList.remove('is-celebrating'); }, 1000);
  }

  // Reconecta el observer inmediatamente tras escribir. Es seguro hacerlo de
  // forma síncrona porque render() NO modifica los atributos observados
  // (data-cart-total / data-amount-cents / data-shp-projection); solo escribe
  // class, data-stage, style y textos — ninguno dispara el filtro.
  function reconnect(root, observer) {
    observer.observe(root, {
      attributes: true,
      attributeFilter: ['data-cart-total', 'data-amount-cents', 'data-shp-projection']
    });
  }

  // Inicializa un contenedor: observer + primer render.
  function init(root) {
    if (root.__shpInit) return;
    root.__shpInit = true;
    root.__prevStage = null;

    var observer = new MutationObserver(function () { render(root); });
    root.__shpObserver = observer;
    render(root);                                   // render inicial (conecta al final)
  }

  // Encuentra e inicializa todas las barras presentes.
  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.cart-shipping.js-cart-shipping');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  // Re-render de todas las barras (para eventos del tema).
  function refreshAll() {
    var nodes = document.querySelectorAll('.cart-shipping.js-cart-shipping');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].__shpInit) render(nodes[i]); else init(nodes[i]);
    }
  }

  // --- Arranque ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // El drawer/carrito pueden inyectarse después: observa el body para
  // detectar barras nuevas y reaplicar (ligero, solo childList en body).
  var bodyObserver = new MutationObserver(function () { initAll(); });
  if (document.body) {
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    });
  }

  // --- Integración con el tema Ultra/Adastra (EventBus propio) ---
  // El tema emite 'cart:updated' por window.themeCore.EventBus (no por eventos DOM).
  // El evento NO trae el total del carrito: al recibirlo consultamos /cart.js
  // (fuente de verdad) y actualizamos data-cart-total de TODAS las barras.
  // La mutación del atributo dispara el render vía el observer de cada barra.
  function refreshFromCartJs() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('.cart-shipping.js-cart-shipping');
        for (var i = 0; i < nodes.length; i++) {
          if (!nodes[i].__shpInit) init(nodes[i]);
          nodes[i].setAttribute('data-cart-total', String(cart.total_price));
        }
      })
      .catch(function () { /* sin red: se mantiene el último estado */ });
  }

  function hookEventBus(retries) {
    if (window.themeCore && window.themeCore.EventBus && typeof window.themeCore.EventBus.listen === 'function') {
      window.themeCore.EventBus.listen('cart:updated', refreshFromCartJs);
      return;
    }
    if (retries > 0) window.setTimeout(function () { hookEventBus(retries - 1); }, 250);
  }
  hookEventBus(40); // hasta ~10s esperando la inicialización del EventBus del tema

  // Fallback defensivo: eventos DOM genéricos por si algún flujo los emite.
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, refreshFromCartJs);
  });
  document.addEventListener('shopify:section:load', function () { initAll(); });

  // API pública para integración manual desde el JS del tema:
  //   ArmasShippingBar.setTotal(nodeOrSelector, totalCents)
  //   ArmasShippingBar.refresh()
  window.ArmasShippingBar = {
    init: initAll,
    refresh: refreshAll,
    setTotal: function (target, totalCents) {
      var node = typeof target === 'string' ? document.querySelector(target) : target;
      if (!node) return;
      node.setAttribute('data-cart-total', String(totalCents));
      // la mutación dispara el observer; si aún no hay observer, render directo:
      if (!node.__shpInit) init(node);
    }
  };
})();
